import { Rive } from '@rive-app/canvas';
import { LayoutBase } from './LayoutBase';
import { emitter, EventType } from '@/utils/emitter.utils';
import { dataSourceWholeItems } from '@/resources/data-source';
import { RendererRuntime } from '../runtime';
import { useEditorStore } from '@/store/use-editor-store';

export default class extends LayoutBase {
  getSize(): { width: number; height: number } {
    return {
      width: 0,
      height: 0
    };
  }

  private setRiveInputs(rive: Rive, riveFilename: string) {
    if (!rive.stateMachineNames?.length) return;

    const editorStore = useEditorStore();
    // 设置色值
    const { ast, renderTheme } = this.renderer.options;
    const color = renderTheme.themeColor;
    const colors =
      ast.attrsMap['colorGroupTable'] ?? ast.attrsMap['recolorTable'] ?? '';
    const colorIndex = colors.split(',').findIndex((item) => item === color);

    const sourceKeys: string[] = [];

    rive.stateMachineInputs(rive.stateMachineNames?.[0])?.forEach((item) => {
      const { value, name } = item;
      console.log('获取rive中参数', 'name = ' + name, 'value = ' + value);

      // 主题色
      if (['color', 'themeColor'].includes(name) && colorIndex > -1) {
        if (value != colorIndex) item.value = colorIndex;
      }
      // 样式ID（theme），采用renderer传入的主题index（截图），不存在则使用editorStore的index
      if (name === 'themeID') {
        const themeIndex =
          this.renderer.options.renderTheme.index ??
          editorStore.themePositionIndex;
        if (themeIndex >= 0 && value != themeIndex) item.value = themeIndex;
      }
      let reName = name;
      if (name === 'timeHourInt') reName = 'timeHour'; // 工具不支持的数据源
      if (name === 'timeSecondInt') {
        reName = 'timeSecond'; // 工具不支持的数据源
        console.log('[Rive] timeSecondInt 已识别，映射到 timeSecond');
      }
      if (this.runtime.configDataWhole[reName] != undefined) {
        // 数据源
        const val = this.getDataSourceValue(reName);
        if (val != value)
          // timeHourInt、timeMinute、timeSecondInt三个数据源在rive中要向下取整
          item.value =
            name == 'timeHourInt' ||
            name == 'timeMinute' ||
            name == 'timeSecondInt'
              ? Math.floor(Number(val))
              : Number(val);
        sourceKeys.push(reName);
      }
    });

    // 如果没有获取过文本类数据源
    if (!RendererRuntime.riveTextRunNames[riveFilename]?.length) {
      RendererRuntime.riveTextRunNames[riveFilename] = ['null'];
      dataSourceWholeItems.forEach((item) => {
        const val = rive.getTextRunValue(item.key);
        if (val != undefined) {
          RendererRuntime.riveTextRunNames[riveFilename].push(item.key);
        }
      });
    }

    RendererRuntime.riveTextRunNames[riveFilename].forEach((key) => {
      if (key == 'null') return;
      const val = this.getDataSourceValue(key);
      if (val != undefined) rive.setTextRunValue(key, String(val));
      sourceKeys.push(key);
    });

    this.setRuntimeData({
      riveSourceKeys: sourceKeys
    });
    emitter.emit(EventType['renderer:rive-set-inputs']);
    this.renderer.riveInputsDirty = false;
  }

  private drawRive() {
    const { x, y, ctx } = this;
    // 获取offscreenCanvas
    const { canvas, rive, filename = '' } = this.runtime.rive ?? {};
    if (!canvas || !rive || !canvas.width) return;

    if (this.renderer.riveInputsDirty) {
      this.setRiveInputs(rive, filename);
    }
    ctx.drawImage(canvas, x, y);
  }

  private async drawRivePreview() {

    const { x, y, ctx } = this;
    const { rivePreviewImgEl } = this.runtime.rive ?? {};
    if (!rivePreviewImgEl) return;
    ctx.drawImage(rivePreviewImgEl, x, y);
  }

  draw(): void {
    const { dataItem } = this;
    const { fileName = '', fileNameExt = '' } = dataItem as IFile;
    const { useRivePreview = false, rivePreviewImgEl } =
      this.runtime.rive ?? {};

    // 目前仅处理rive文件
    const isRive = fileName.endsWith('.riv') || fileNameExt.endsWith('.riv');

    if (isRive) {
      useRivePreview && rivePreviewImgEl
        ? this.drawRivePreview()
        : this.drawRive();
    } else {
      // Todo 其他文件
    }
  }
}
